import JwtService from '@common/JwtService'
import { BASE_URL } from '@common/ApiService'
import ActionCable from 'actioncable'

let consumer = null

export const createConsumer = () => {
  if (consumer) return consumer

  const token = JwtService.getToken()
  if (!token) {
    return null
  }

  const webSocketUrl = `${BASE_URL.replace('http', 'ws')}/cable?token=${token}&app_id=pas`
  consumer = ActionCable.createConsumer(webSocketUrl)
  return consumer
}
